<template>
    <div class="user-controls">
        <div class="ah-container">
            <div class="wrapper">
                <div class="branding">
                    <img class="ahoo-logo hide-in-mobile" src="@/assets/img/brand-logo-single-color.svg" />
                    <accCenterCompanySwitch v-if="isSwitchShow" />
                    <template v-else>
                        <div class="pay-version hide-in-mobile">{{ $store.getters["account/pdT_TYP"] }}</div>
                        <div class="company-name">
                            {{ $store.getters["menu/companyInfo"].cH_CMP }}<span v-if="isTrying">（試用）</span>
                        </div>
                    </template>
                </div>
                <div class="user-menu">
                    <div class="item clickable hide-in-mobile" v-if="showIndex">
                        <div class="text" @click="$router.push({ name: 'index' })">回首頁</div>
                    </div>
                    <div class="item clickable hide-in-mobile" v-if="isShowAccAnnouncement">
                        <div class="text" @click="$emit('accAnnouncementClick')">會計專區公告</div>
                    </div>
                    <div class="item clickable hide-in-mobile" v-if="showSetup">
                        <div class="text" @click="$router.push({ name: 'setup-start' })" v-if="isQualifiedInitUser && !isQR()">
                            系統啟用指引
                        </div>
                    </div>
                    <div class="item clickable hide-in-mobile">
                        <div class="text" @click="onRecount" v-if="isAuthOne(['A02', 'A03', 'B02', 'B03']) && !isQR()">
                            重算
                        </div>
                    </div>
                    <div class="item clickable hide-in-mobile">
                        <div class="text" @click="onNetworkDiagnostic">
                            測速
                        </div>
                    </div>
                    <div class="item clickable hidden-xs-only">
                        <div class="text" @click="openAhooAgent">Sokuji 客服</div>
                    </div>
                    <div class="item hide-in-mobile">
                        <div class="text version">v{{ currVersion }}</div>
                    </div>
                    <div class="item">
                        <div class="text">
                            <el-button type="text" style="padding: unset" @click="onUserBtnClick">
                                <img
                                    class="icon"
                                    src="@/assets/img/icon-user.svg"
                                    style="
                                        display: inline-block;
                                        vertical-align: bottom;
                                        margin-right: 4px;
                                    "
                                    alt=""
                                />
                                <span style="font-weight: bold">{{ userName }}{{ userGroupName }}</span>
                            </el-button>
                        </div>
                    </div>
                    <div class="item">
                        <div class="text">
                            <span class="hide-in-mobile logout-countdown">
                                <el-popover placement="top-end" title="" width="300" trigger="hover">
                                    <div>
                                        <div style="font-size: 11pt; margin-top: 5px">
                                            設定閒置登出期限：
                                        </div>
                                        <div style="margin-top: 15px">
                                            <el-radio-group v-model="autoLogoutSetting.logoutSpan" size="small" @change="handleAutoLogoutSettingTimespanChange">
                                                <el-radio-button label="10">10分鐘</el-radio-button>
                                                <el-radio-button label="30">30分鐘</el-radio-button>
                                                <el-radio-button label="60">1小時</el-radio-button>
                                                <el-radio-button label="240">4小時</el-radio-button>
                                            </el-radio-group>
                                        </div>
                                    </div>
                                    <span type="text" slot="reference"
                                        ><span style="text-decoration: underline">{{ logoutTimeLeftTxt }}</span> 後</span
                                    >
                                </el-popover>
                            </span>
                            <template v-if="userGroupNo === 'OT4'">
                                <span class="logout-btn hide-in-mobile" @click="handleLogoutBtnClick">回 Sokuji 財務作業</span>
                            </template>
                            <template v-if="['OT1', 'OT2', 'OT3', 'OT4', 'OT5', 'OT6'].includes(userGroupNo)">
                                <span class="logout-btn dark" @click="onBackToAccBtnClick">回會計服務專區</span>
                            </template>
                            <template v-if="!['OT1', 'OT2', 'OT3', 'OT4'].includes(userGroupNo)">
                                <span class="logout-btn ghost" @click="handleLogoutBtnClick">登出</span>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <LogoutWarningDialog :visible="logoutClock.warningVisible" :timeLeft="logoutClock.timeLeft" @close="handleLogoutWarningClose" />
    </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex';
import accCenterCompanySwitch from '@/components/ui/accCenterCompanySwitch.vue';
import LogoutWarningDialog from './LogoutWarningDialog.vue';

export default {
    name: 'UserControls',
    components: { LogoutWarningDialog, accCenterCompanySwitch },
    props: ['showSetup', 'showIndex'],
    data() {
        return {
            currVersion: '',
            autoLogoutSetting: {
                logoutSpan: 30,
            },
            logoutClock: {
                timer: null,
                logoutTime: null,
                timeLeft: null,
                logoutDuration: 30 * 60 * 1000,
                warningTime: 1 * 60 * 1000,
                warningVisible: false,
            },
        };
    },

    mounted() {
        const pjson = require('/package.json');
        this.currVersion = pjson.version;
        this.logoutClock.logoutDuration = this.logoutTimespan * 60 * 1000;
        this.autoLogoutSetting.logoutSpan = this.logoutTimespan;
        this.startLogoutTimer();
    },
    computed: {
        ...mapGetters({
            isTrying: 'menu/isTrying',
            userGrP_NO: 'account/userGrP_NO',
        }),
        userName() {
            return this.$store.getters['account/userName'];
        },
        userGroupNo() {
            return this.$store.getters['account/userGrP_NO'];
        },
        userGroupName() {
            if (this.userGroupNo === 'OT1') {
                return '(會計查帳)';
            }
            if (this.userGroupNo === 'OT2') {
                return '(財務顧問)';
            }
            if (this.userGroupNo === 'OT3') {
                return '(小秘書)';
            }
            if (this.userGroupNo === 'OT4') {
                return '(公司會計)';
            }
            if (this.userGroupNo === 'OT5') {
                return '(會計記帳)';
            }
            if (this.userGroupNo === 'OT6') {
                return '(歷史查帳)';
            }
            return '';
        },
        isQualifiedInitUser() {
            return (
                this.isAuth('F03') // 銀行帳戶設定
                && this.isAuth('F05') // 收支項目設定
                && this.isAuth('F22') // 審核流程設定
                && this.isAuth('F23') // 公司資訊設定
                && this.isAuth('E02')
            ); // 零用現金管理
        },
        logoutTimeLeftTxt() {
            const allsec = Math.ceil(this.logoutClock.timeLeft / 1000);
            return this.toHHMMSS(allsec);
        },
        logoutTimespan() {
            const lt = localStorage.getItem('logoutTimespan');
            if (lt) return parseInt(localStorage.getItem('logoutTimespan'), 10);
            return 30;
        },
        envName() {
            return process.env.VUE_APP_ENV_NAME;
        },
        isSwitchShow() {
            return this.userGrP_NO === 'OT1' || this.userGrP_NO === 'OT2' || this.userGrP_NO === 'OT3' || this.userGrP_NO === 'OT4';
        },
        isShowAccAnnouncement() {
            // 有下面權限任一才看得見公告：填寫付款明細(A02)、確認付款(A03)、分析/營業收支總覽(D11)
            if (!this.isAuthOne(['A02', 'A03', 'D11'])) {
                return false;
            }
            return true;
        },
    },
    methods: {
        ...mapMutations({
            updateReCalculateDialogVisible: 'globalDialogState/updateReCalculateDialogVisible',
            updateNetworkDiagnosticDialogVisible: 'globalDialogState/updateNetworkDiagnosticDialogVisible',
        }),
        onUserBtnClick() {
            if (this.$store.getters['account/userSno'] !== 1 && this.$store.getters['account/userSno'] !== 2) {
                this.$router.push({ name: 'profile' });
            }
        },
        openAhooAgent() {
            window.open('https://line.me/R/ti/p/@056wdwcl', '_blank');
        },
        startLogoutTimer() {
            this.resetLogoutTimer();
            this.logoutClock.timer = setInterval(this.logoutClockRunning, 1000);

            document.addEventListener('click', () => {
                this.resetLogoutTimer();
            });
        },

        resetLogoutTimer() {
            this.logoutClock.logoutTime = new Date().getTime() + this.logoutClock.logoutDuration;
        },

        logoutClockRunning() {
            const currentTime = new Date().getTime();
            this.logoutClock.timeLeft = this.logoutClock.logoutTime - currentTime;

            if (this.logoutClock.timeLeft <= this.logoutClock.warningTime) {
                if (!this.logoutClock.warningVisible) {
                    this.logoutClock.warningVisible = true;
                }
            }

            if (this.logoutClock.timeLeft < 0) {
                clearInterval(this.logoutClock.timer);
                this.logout();
            }
        },

        logout() {
            this.$store.dispatch('account/logout').then(() => {
                this.$router.push('/login');
            });
        },

        handleLogoutBtnClick() {
            this.logout();
        },
        onBackToAccBtnClick() {
            this.$store.dispatch('account/logout').then(() => {
                let accUrl = 'https://acc.sokuji.tw/';
                if (process.env.VUE_APP_ENV_NAME === 'stage') {
                    accUrl = 'https://stageacc.sokuji.tw/';
                }
                if (process.env.VUE_APP_ENV_NAME === 'dev') {
                    accUrl = 'https://devacc.sokuji.tw/';
                }
                window.location.href = accUrl;
            });
        },
        handleLogoutWarningClose(isLogout) {
            this.logoutClock.warningVisible = false;

            if (isLogout) {
                this.logout();
            }
        },
        handleAutoLogoutSettingTimespanChange(val) {
            localStorage.setItem('logoutTimespan', val);
            this.logoutClock.logoutDuration = val * 60 * 1000;
            this.resetLogoutTimer();
        },
        toHHMMSS(secs) {
            const sec_num = parseInt(secs, 10);
            const hours = Math.floor(sec_num / 3600);
            const minutes = Math.floor(sec_num / 60) % 60;
            const seconds = sec_num % 60;

            return [hours, minutes, seconds]
                .map((v) => (v < 10 ? `0${v}` : v))
                .filter((v, i) => v !== '00' || i > 0)
                .join(':');
        },
        onRecount() {
            this.updateReCalculateDialogVisible(true);
        },
        onNetworkDiagnostic() {
            this.updateNetworkDiagnosticDialogVisible(true);
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

$top-control-height: 35px;

.user-controls {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: $top-control-height;
    background-color: #f4f4f6;
    color: #666;
    text-align: right;
    z-index: 10;

    @media print {
        display: none;
    }

    .wrapper {
        display: flex;
        justify-content: space-between;
    }

    .branding {
        display: flex;
        align-items: center;
        height: $top-control-height;
        font-size: 9pt;
        line-height: unset;

        .ahoo-logo {
            height: 18px;
            margin-right: 10px;
        }

        .pay-version {
            position: relative;
            display: inline-block;
            vertical-align: top;
            font-weight: bold;
            margin-right: 10px;
        }

        .company-name {
            display: inline-block;
            margin-left: 10px;
            color: $main-color;
            font-weight: bold;
            font-size: 11pt;

            @media (max-width: 1024px) {
                text-wrap: nowrap;
                max-width: 180px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }
        }
    }

    .hide-in-mobile {
        @media (max-width: 768px) {
            display: none;
        }
    }

    .user-menu {
        .item {
            display: inline-block;
            cursor: default;
            padding: 0 10px;
            font-size: 10pt;
            // font-weight: bold;
            line-height: 20px;
            margin: 8px 0;
            vertical-align: top;

            &:first-child {
                border-left: 0;
            }

            &.clickable:hover {
                cursor: pointer;
                color: $main-color;
            }

            &.hide-in-mobile {
                @media (max-width: 768px) {
                    display: none;
                }
            }

            .icon {
                width: 16px;
                vertical-align: top;
            }

            .version {
                color: $main-color;
                text-decoration: none;

                &:hover {
                    color: $main-color;
                }
            }
        }
    }

    .logout-countdown {
        margin-right: 10px;;
    }

    .logout-btn {
        background-color: $main-color;
        padding: 4px 10px;
        font-size: 9pt;
        font-weight: bold;
        margin-left: 5px;
        border-radius: 6px;
        color: #fff;
        cursor: pointer;
        opacity: 0.9;

        &:hover {
            opacity: 1;
        }

        &.dark {
            background-color: #151A4C;
            border: 1px solid #151A4C;

        }
        &.gray {
            background-color: #adacb4;
            border: 1px solid #adacb4;
        }
        &.ghost {
            border: 1px solid $main-color;
            color: $main-color;
            background-color: transparent
        }
    }
}
</style>
